import React, { useState, useEffect } from 'react'
import { Table, Row, Col } from 'rsuite'
import EditSelectCell from '../../components/cell/EditSelectCell'
import EditTextCell from '../../components/cell/EditTextCell'
import EditNumberCell from '../../components/cell/EditNumberCell'

import SaveButton from '../../components/buttons/saveButton/SaveButton'
import EditButton from '../../components/buttons/editButton/EditButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { cloneDeep } from 'lodash'
import notification from '../../utils/notification'
import { budgetFormat } from '../../utils/formatterUtil'
import { v4 as uuidv4 } from 'uuid'
import '../../widgets/projectBasedItemsWidget/styles_table.less'
import { hasMinValidator } from '../../utils/ValidatorUtils'

export default function UpdateListTable({ schema, loading, enableEdit, isAddDisabled, ...props }) {
  const { register, errors, control, setError, setValue, getValues, clearErrors } = props

  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [showControlEdit, setShowControlEdit] = useState(true)
  const [masterTableData, setMasterTableData] = useState([])
  const [masterExpenseType, setMasterExpenseType] = useState([])

  useEffect(() => {
    console.log('reload')
    setMasterTableData(schema.values || [])
    setTableData(schema.values || [])
    register('table', schema.values || [])
    setValue('table', schema.values || [])
  }, [schema])

  useEffect(() => {
    if (schema?.activityRelations && schema?.activityRelations?.length > 0) {
      let convertData = schema?.activityRelations?.map((item) => {
        return {
          ...item,
          label: item.typeName,
          value: item.typeCode,
        }
      })

      convertData.sort((a, b) => parseInt(a.typeCode) - parseInt(b.typeCode))
      setMasterExpenseType(convertData || [])
    } else {
      let convertData = schema?.expenseType?.options.map((item) => {
        return {
          ...item,
          typeName: item.label,
          typeCode: item.value,
        }
      })
      setMasterExpenseType(convertData || [])
    }
  }, [schema.activityRelations])

  useEffect(() => {
    if (errors) {
      console.log('errors', errors)
      let key = Object.keys(errors)
      if (key.length > 0) {
        notification.open('error', {
          title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
          duration: 5000,
        })
      }
    }
  }, [errors])

  const handleOpenEditRow = (rowData) => {
    const newData = tableData.map((row) => {
      if (row.id == rowData.id) {
        if (rowData.status && rowData.status == 'EDIT') {
          const master = masterTableData.find((item) => item.id == rowData.id)
          row.activity = master?.activity
          row.adjustName = master?.adjustName
          row.adjustType = master?.adjustType
          row.subProject = master?.subProject
          row.bankAccount = master?.bankAccount
          row.amount = master?.amount
          row.status = null
        } else {
          row.status = 'EDIT'
        }
      }
      return row
    })

    handleChangeTotal(newData)
  }

  const handleChangeTotal = (dataTable) => {
    if (dataTable?.length > 0) {
      var totalAmount = 0

      dataTable.forEach((e) => {
        if (!e.isRowTotal) {
          totalAmount += e.amount
        }
      })

      dataTable[dataTable.length - 1].amount = totalAmount

      setTableData(dataTable)
      setValue('table', dataTable)
    }
  }

  const onChangeTableValue = (index, value = 0, key) => {
    let datas = cloneDeep(tableData)
    datas[index][key] = value

    console.log('datas', datas)

    //setTableData(datas)
    //setValue('table', datas)
    handleChangeTotal(datas)
  }

  const onDeleteRow = (rowData) => {
    let datas = cloneDeep(tableData)

    datas = datas.filter((e) => e.id != rowData.id)

    var sumObj = {}
    if (datas?.length > 0) {
      sumObj = datas[datas.length - 1]

      sumObj.amount = 0

      datas?.splice(-1)
    } else {
      datas = []

      sumObj = {
        amount: 0,
        totalText: 'รวม (บาท)',
        isRowTotal: true,
      }
    }

    datas.forEach((e) => {
      sumObj.amount = sumObj.amount + e.amount
    })

    datas.push(sumObj)

    setTableData(datas)

    setValue('table', datas)
  }

  const handleOnClickAddNewData = () => {
    // setTableData()
    let datas = cloneDeep(tableData)

    //var lasted = datas[datas.length-1]
    var runnigNum = 1
    var sumObj = {}
    if (datas && datas?.length > 0) {
      runnigNum = datas.length - 1
      sumObj = datas[datas.length - 1]

      sumObj.amount = 0

      datas?.splice(-1)
    } else {
      datas = []

      sumObj = {
        amount: 0,
        totalText: 'รวม (บาท)',
        isRowTotal: true,
      }
    }

    var newObj = {
      id: 'addNew-' + runnigNum + '-' + uuidv4(),
      activity: '',
      adjustName: '',
      adjustType: '',
      bankAccount: '',
      subProject: '',
      amount: 0,
      isDeletable: true,
      status: 'EDIT',
    }

    datas.push(newObj)

    datas.forEach((e) => {
      sumObj.amount = sumObj.amount + e.amount
    })

    datas.push(sumObj)

    setTableData(datas)
    setValue('table', datas)
  }

  const setAdjustTypeCodeOptions = (rowData, index) => {
    let rowSchema = cloneDeep(schema.adjustTypeCode)
    var options = schema.adjustTypeCode.options

    if (index > 0 && index % 2 == 1) {
      let adjustTypeCode = schema.adjustTypeCode.options.find(
        (e) => e.value == tableData[index - 1].adjustTypeCode
      )

      if (adjustTypeCode?.subOptions?.length > 0) {
        options = adjustTypeCode.subOptions
      }

      if (rowData.activity) {
        let masters = [
          ...new Map(
            masterExpenseType
              .filter((i) => rowData.activity == i.activityCode)
              ?.map((item) => [item['typeCode'], item])
          ).values(),
        ]

        options = masters
          .filter((i) => options.some((e) => e.value == i.value))
          ?.map((e) => ({ value: e.value, label: e.label }))
      }
    } else if (rowData.activity) {
      let masters = [
        ...new Map(
          masterExpenseType
            .filter((i) => rowData.activity == i.activityCode)
            ?.map((item) => [item['typeCode'], item])
        ).values(),
      ]

      options = masters?.map((e) => ({ value: e.value, label: e.label }))
    }

    rowSchema.options = options

    return rowSchema
  }

  return (
    <>
      <div className="table-affix-header">
        <Table
          shouldUpdateScroll={false}
          wordWrap
          minHeight={50}
          autoHeight
          loading={loading}
          data={tableData}
          style={{ marginTop: '20px' }}
          affixHeader
        >
          <Column width={90} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.isRowTotal) {
                  return ''
                }
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={300} minWidth={300} flexGrow={1}>
            <HeaderCell>กิจกรรม</HeaderCell>
            {/* <Cell dataKey="list" /> */}
            <Cell>
              {(rowData, index) => {
                // console.log('row data ', !rowData.isDeletable, rowData.activityId)
                if (!rowData.isDeletable) {
                  return rowData.activityName
                }

                if (rowData.status != 'EDIT') {
                  return rowData.activityName
                }

                return (
                  <EditSelectCell
                    id={`${schema.activity.name}_${rowData.id}`}
                    //id={`table[${index}].${schema.activity.name}`}
                    rowData={rowData}
                    rowSchema={schema.activity}
                    dataKey={schema.activity.name}
                    register={register}
                    control={control}
                    errors={errors}
                    cleanable={true}
                    searchable={true}
                    onChangeCell={(value) => onChangeTableValue(index, value, schema.activity.name)}
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={300} minWidth={300} flexGrow={1}>
            <HeaderCell>รายการ/ประเภทค่าใช้จ่าย</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.status != 'EDIT' || !rowData.isDeletable) {
                  return rowData.adjustTypeCodeName
                }

                let rowSchema = setAdjustTypeCodeOptions(rowData, index)

                return (
                  <EditSelectCell
                    id={`${schema.adjustTypeCode.name}_${rowData.id}`}
                    rowData={rowData}
                    rowSchema={rowSchema}
                    // rowSchema={{
                    //   ...schema.adjustTypeCode,
                    //   options: [
                    //     ...(rowData.activity
                    //       ? new Map(
                    //           masterExpenseType
                    //             .filter(
                    //               (i) => rowData.activity == i.activityCode
                    //               //|| (!rowData.activity && !i.activityCode)
                    //             )
                    //             ?.map((item) => [item['typeCode'], item])
                    //         ).values()
                    //       : schema.adjustTypeCode.options),
                    //   ],
                    // }}
                    dataKey={schema.adjustTypeCode.name}
                    register={register}
                    control={control}
                    errors={errors}
                    cleanable={true}
                    searchable={true}
                    onChangeCell={(value) =>
                      onChangeTableValue(index, value, schema.adjustTypeCode.name)
                    }
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={300}>
            <HeaderCell>รายการ</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (!rowData.isDeletable) {
                  return rowData.adjustName
                }

                return (
                  <EditTextCell
                    id={`${schema.adjustName.name}_${rowData.id}`}
                    //id={`table[${index}].${schema.adjustName.name}`}
                    rowSchema={schema.adjustName}
                    rowData={rowData}
                    dataKey={schema.adjustName.name}
                    register={register}
                    control={control}
                    errors={errors}
                    onChangeCell={(value) =>
                      onChangeTableValue(index, value, schema.adjustName.name)
                    }
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={180}>
            <HeaderCell>ประเภทการปรับปรุง</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.status != 'EDIT' || !rowData.isDeletable) {
                  return rowData.adjustTypeName
                }

                return (
                  <EditSelectCell
                    id={`${schema.adjustType.name}_${rowData.id}`}
                    //id={`table[${index}].${schema.activity.name}`}
                    rowData={rowData}
                    rowSchema={schema.adjustType}
                    dataKey={schema.adjustType.name}
                    register={register}
                    control={control}
                    errors={errors}
                    cleanable={false}
                    searchable={false}
                    onChangeCell={(value) =>
                      onChangeTableValue(index, value, schema.adjustType.name)
                    }
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={300}>
            <HeaderCell>ธนาคาร</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.adjustTypeCode != '6600' && rowData.adjustTypeCode != '6800') {
                  return ''
                }

                if (!rowData.isDeletable || rowData.status != 'EDIT') {
                  return rowData.bankAccountName
                }

                //กรณีเลือกประเภทรายการเงินฝาก 6600  เพิ่ม validator
                if (rowData.adjustTypeCode == '6600') {
                  const bankAccountSchema = {
                    ...schema.bankAccount,
                    validators: [
                      ...schema.bankAccount.validators,
                      schema.bankAccount.validators6800,
                    ],
                  }

                  return (
                    <EditSelectCell
                      id={`${bankAccountSchema.name}_${rowData.id}`}
                      //id={`table[${index}].${schema.activity.name}`}
                      rowData={rowData}
                      rowSchema={bankAccountSchema}
                      dataKey={bankAccountSchema.name}
                      register={register}
                      control={control}
                      errors={errors}
                      cleanable={true}
                      searchable={true}
                      onChangeCell={(value) =>
                        onChangeTableValue(index, value, bankAccountSchema.name)
                      }
                    />
                  )
                }

                return (
                  <EditSelectCell
                    id={`${schema.bankAccount.name}_${rowData.id}`}
                    //id={`table[${index}].${schema.activity.name}`}
                    rowData={rowData}
                    rowSchema={schema.bankAccount}
                    dataKey={schema.bankAccount.name}
                    register={register}
                    control={control}
                    errors={errors}
                    cleanable={true}
                    searchable={true}
                    onChangeCell={(value) =>
                      onChangeTableValue(index, value, schema.bankAccount.name)
                    }
                  />
                )
              }}
            </Cell>
          </Column>

          {/* <Column width={300}>
          <HeaderCell>โครงการย่อย</HeaderCell>
          <Cell>
            {(rowData, index) => {
              if (rowData.isRowTotal) {
                return (
                  <div style={{ width: '100%', fontWeight: 550, textAlign: 'right' }}>
                    <b>{rowData.totalText || 'รวม (บาท)'}</b>
                  </div>
                )
              } else if (!rowData.isDeletable) {
                return rowData.subProject
              } else if (rowData.status != 'EDIT') {
                return rowData.subProjectName
              }

              return (
                <EditSelectCell
                  id={`${schema.subProject.name}_${rowData.id}`}
                  //id={`table[${index}].${schema.activity.name}`}
                  rowData={rowData}
                  rowSchema={schema.subProject}
                  dataKey={schema.subProject.name}
                  register={register}
                  control={control}
                  errors={errors}
                  cleanable={true}
                  searchable={true}
                  onChangeCell={(value) => onChangeTableValue(index, value, schema.subProject.name)}
                />
              )
            }}
          </Cell>
        </Column> */}

          <Column width={150}>
            <HeaderCell align="right">จำนวนเงิน</HeaderCell>
            <Cell align="right">
              {(rowData, index) => {
                if (rowData.isRowTotal) {
                  return (
                    <span
                      style={{ fontWeight: 550 }}
                      className={'cost-total-summary'}
                    >{`${budgetFormat(rowData?.amount || 0)}`}</span>
                  )
                }
                return (
                  <EditNumberCell
                    id={`${schema.amount.name}_${rowData.id || rowData.makeId}`}
                    rowData={rowData}
                    dataKey={schema.amount.name}
                    register={register}
                    control={control}
                    errors={errors}
                    isRequired={true}
                    isBudgetFormat={true}
                    styleSheet={{ marginTop: 8, textAlign: 'right' }}
                    onChangeCell={(value) => onChangeTableValue(index, value, schema.amount.name)}
                    allowNegative={!hasMinValidator(schema.amount.validators)}
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={180} align="center">
            <HeaderCell>วันที่บันทึกรายการ</HeaderCell>
            <Cell dataKey="createDate" />
          </Column>

          {enableEdit && (
            <Column width={180} align="center" fixed="right">
              <HeaderCell>จัดการรายการ</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  if (rowData.isRowTotal) {
                    return ''
                  }
                  return (
                    <>
                      <EditButton
                        //style={{ marginRight: 5 }}
                        onClick={() => handleOpenEditRow(rowData)}
                        size="sm"
                        icon={rowData.status == 'EDIT' ? 'close' : 'edit'}
                      >
                        {rowData.status == 'EDIT' ? 'ยกเลิก' : 'แก้ไข'}
                      </EditButton>

                      <CancelButton
                        style={{
                          //marginRight: 10,
                          marginBottom: 10,
                        }}
                        onClick={() => {
                          onDeleteRow(rowData)
                        }}
                        size="sm"
                        icon="trash-o"
                        disabled={!rowData.isDeletable}
                      >
                        ลบ
                      </CancelButton>
                    </>
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>
      </div>

      {enableEdit && (
        <div style={{ marginTop: 10 }}>
          <Row>
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <SaveButton
                icon="plus"
                onClick={() => handleOnClickAddNewData()}
                disabled={isAddDisabled}
                //disabled={tableData.find((i) => i.id.indexOf('sendTax') > 0)}
                style={{ marginRight: 10 }}
              >
                เพิ่มรายการ
              </SaveButton>
            </Col>
          </Row>
        </div>
      )}
    </>
  )
}
